export enum LocalStorageKeys {
  Alias = 'Alias',
}
